import { useRef, useState, useEffect } from "react";
import IframeResizer from 'iframe-resizer-react'
import HttpService from "../../services/HttpService";

import LoaderBar from "../shared/LoaderBar";
import "../../scss/LearningHub.scss"

export default function Calculators() {
  const userAttributes = JSON.parse(sessionStorage.getItem("attributeData")) ?? null;
  // eslint-disable-next-line no-unused-vars
  const [messageData, setMessageData] = useState()
  const [isLoading, setIsLoading] = useState(true);
  const [quickli, setQuickli] = useState();
  const [error, setError] = useState(false);

  const iframeRef = useRef(null)

  const userDetails = {
      "email": userAttributes.email,
      "firstName": userAttributes.given_name,
      "lastName": "LastName",
      "mobile": "0400000000",
      "redzedId": userAttributes.preferred_username,
      "metaData": [
        {
          "request": "true"
        }
      ]
  }

  const onResized = data => setMessageData(data)

  const onMessage = data => {
    setMessageData(data)
    iframeRef.current.sendMessage('Hello back from the parent page')
  }

  const loginQuickli = async() => {
    const data = await HttpService.post(`Quickli/Login`, userDetails);
    return data;
  }

  useEffect(() => {
    loginQuickli().then((response) => {
      // const res = JSON.parse(response);
      setQuickli(response);
      
      if(response){
        setIsLoading(false)
      } else {
        setIsLoading(false);
        setError(true);
      }
    })
    .catch((error) => {
      console.log('error: ', error)
    });

  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  if(isLoading) {
    return <LoaderBar />
  }

  if (!error) {
    return (
      <div className="academy-iframe-wrapper w-full absolute left-0">
        <IframeResizer
          src={quickli}
          heightCalculationMethod="lowestElement"
          autoResize={true}
          scrolling={true}
          onMessage={onMessage}
          onResized={onResized}
          style={{ width: '1px', minWidth: '100%'}}
        />
      </div>
    )
  } else {
    return (
      <div className="flex flex-wrap">
        <div className="w-full text-center">
          <h2 className="font-semibold">An error occured, please try again later.</h2>
          <p>If the problem persists, please contact Client Services on <a href={`tel:${process.env.REACT_APP_COMPANY_PHONE}`}>{process.env.REACT_APP_COMPANY_PHONE}</a> or <a href={`mailto:${process.env.REACT_APP_COMPANY_EMAIL}`}>{process.env.REACT_APP_COMPANY_EMAIL}</a></p>
        </div>
      </div>
    )
  }
}